class SecondaryNav extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();

        // Cast open attribute to a Boolean, so !this.open works correctly
        this.open = this.getAttribute('open') === 'true' ? true : false;
        this.btn = this.querySelector('.secondary-nav-btn');
        this.secondaryNavList = this.querySelector('.secondary-nav-list');
        this.secondaryNavLinks = this.secondaryNavList.querySelectorAll('a');

        this.buildTl();

        // get media query from custom property
        const rootStyle = getComputedStyle(document.documentElement);
        this.maxQuery = rootStyle.getPropertyValue('--max-nav-media-query');
        this.minQuery = rootStyle.getPropertyValue('--min-nav-media-query');
    }

    connectedCallback() {
        this.bindEvents();
    }

    // attributeChangedCallback(name, _oldValue, newValue) {
    //     // do gsap animations here
    //     if (name === 'open' && newValue === true) {
    //         // nav is open
    //         // this.tl.play(0);
    //     } else {
    //         // nav is closed
    //         // this.tl.reverse();
    //     }
    // }

    bindEvents() {
        this.btn.addEventListener('click', () => this.mobileBtnClick());
        this.bindMediaQuery();
    }

    bindMediaQuery() {
        // max nav - mobile
        this.maxMediaQuery = window.matchMedia(this.maxQuery);
        this.maxMediaQuery.addEventListener('change', this.onMaxMediaChange.bind(this));
        this.onMaxMediaChange(this.maxMediaQuery);

        // min nav - desktop
        this.minMediaQuery = window.matchMedia(this.minQuery);
        this.minMediaQuery.addEventListener('change', this.onMinMediaChange.bind(this));
        this.onMinMediaChange(this.maxMediaQuery);
    }

    buildTl() {
        this.tl = gsap.timeline({
            ease: 'sine.out',
            duration: 0.2,
            paused: true,
        });

        this.tl.to(this.secondaryNavList, {
            opacity: 1,
            display: 'block',
        }, 0).to(this.secondaryNavLinks, {
            y: 0,
            opacity: 1,
            stagger: {
                each: 0.05,
            },
            onReverseComplete: () => {
                gsap.to(this.secondaryNavList, {
                    opacity: 0,
                    display: 'none',
                });
            },
        }, '<+=0.1');
    }

    mobileBtnClick() {
        this.open = !this.open;
        this.setAttribute('open', this.open);
    }

    onMaxMediaChange(mobileMediaQuery) {
        // mobile
        if (mobileMediaQuery.matches) {
            this.mobile = true;
            this.desktop = false;
            this.open = false;
            this.setAttribute('open', false);

            // gsap.set(this.secondaryNavList, {clearProps: true});
            // gsap.set(this.secondaryNavLinks, {clearProps: true});
        }
    }

    onMinMediaChange(desktopMediaQuery) {
        // desktop
        if (desktopMediaQuery.matches) {
            this.desktop = true;
            this.mobile = false;
            this.open = false;
            this.setAttribute('open', false);

            // gsap.set(this.secondaryNavList, {clearProps: true});
            // gsap.set(this.secondaryNavLinks, {clearProps: true});
        }
    }
}

customElements.define('secondary-nav', SecondaryNav);
